import React from "react";

function Blog() {
  return(
  <div className="bg-gray-100 xl:h-[40rem] relative top-0  w-full">
    <section className="bg-gray-100 p-6 sm:p-10 md:p-16 lg:p-10 text-left w-[90%] sm:w-[80%] md:w-[80%] lg:w-[80%]
    xl:w-[50%] h-auto mx-auto mt-40 mb-20 xl:ml-40  rounded-lg  ">
      </section>,

  </div>
  );
}

export default Blog;
